import { Tag } from 'sonata-react-components';

import { getGroupTagStyle } from './groupTagStyle';

import type { GroupView } from '../../domain/grouping.types';

export interface GroupTagProps {
  /** Visible groups of the item: one shows its color, several show the multi-group style. */
  groups: Pick<GroupView, 'color' | 'name'>[];
  id: string;
}

/** Read-only group tag, the same one shown on the sidebar list rows. */
export function GroupTag({ groups, id }: Readonly<GroupTagProps>) {
  if (groups.length === 0) {
    return null;
  }
  const names = groups.map(group => group.name).join(', ');
  return (
    <span aria-label={names} className="groupTag" role="img" title={names}>
      <Tag id={id} status="custom" tiny {...getGroupTagStyle(groups)} />
    </span>
  );
}
